import { SHARED_MAILBOX } from 'containers/AwarenessCenter/constants'

import {
  CHANGE_EXCLUDE_FILTER,
  CHANGE_MODAL_SEARCH,
  CHANGE_PAGE,
  CHANGE_SELECTION_DATA,
  GET_PARTICIPANTS_ASYNC,
} from './SetupStep/constants'
import {
  CREATE_CUSTOM_TRAINING_ASYNC,
  CUSTOM_MODULE_NAME_FILE,
  SOURCE_VALUES,
  TRAINING_VIDEO_TYPES,
  UPLOAD_VIDEO_LINK_ASYNC,
} from './TrainingModuleStep/constants'
import {
  ADD_CAMPAIGN_NOTIFICATION,
  APPROVE_CAMPAIGN_ASYNC,
  CHANGE_IS_END_DATE_WAS_MANUALLY_CHANGED,
  CHANGE_LAUNCH_DATE,
  CHANGE_LAUNCH_TIME,
  CHANGE_MANAGER_NOTIFICATION_DATA,
  CHANGE_MANAGER_REPORT_DAY_OF_WEEK,
  CHANGE_MANAGER_REPORT_REMINDERS_THRESHOLD,
  CHANGE_MAX_REMINDERS_PER_PARTICIPANT,
  CHANGE_NAME,
  CHANGE_SEND_COMPLETION_EMAIL,
  CHANGE_SEND_MANAGER_REPORT_EVERY_X_DAYS,
  CHANGE_SEND_REMINDERS_UNTIL,
  CHANGE_TIMEZONE,
  CHANGE_TRAINING_REMINDERS,
  CHANGE_TRIGGER_BASED_CAMPAIGN_DATA,
  DEFAULT_CAMPAIGN_OBJECTS_MAP,
  ERROR_CODES,
  GET_CAMPAIGN_ASYNC,
  GET_CAMPAIGN_LAUNCH_PROPERTIES_MAP,
  INIT_EDIT_MODE,
  PUT_WORKDAYS,
  REMOVE_DRAFT_ASYNC,
  RESET_CAMPAIGN_INPROGRESS_FLAG,
  RESET_WIZARD,
  SAVE_AND_APPROVE_CAMPAIGN_ASYNC,
  SAVE_AND_TEST_CAMPAIGN_ASYNC,
  SAVE_DRAFT_ASYNC,
  SET_CONTROLS_MESSAGE,
  SET_SHARED_MAILBOX_PARTICIPANTS,
  SET_TRAINING_VIDEOS,
  TOGGLE_COMPLETION_NOTIFICATION_SETTING,
  TOGGLE_NOTIFY_THOSE_WHO_FAILED,
  TOGGLE_SEND_CAMPAIGN_SUMMARY_TO_CAMPAIGN_REPORT_RECIPIENTS,
  TOGGLE_SEND_REMINDER_EVERY_X_BUSINESS_DAYS,
  VALIDATORS_MAP,
} from './constants'

export const wizardHandlers = {
  [RESET_WIZARD]: (state, _, campaignType) => ({
    ...state,
    campaign: { ...DEFAULT_CAMPAIGN_OBJECTS_MAP[campaignType] },
    validation: {},
    error: null,
    draftError: null,
    gotApproved: false,
    draftGotManaged: false,
    controlsMessage: '',
  }),
  [INIT_EDIT_MODE]: (state, { payload }) => ({
    ...state,
    loader: true,
    editMode: true,
    campaign: {
      ...state.campaign, // NOTE: probably not really the case
      id: payload.campaignId,
    },
  }),
  [PUT_WORKDAYS]: (state, { payload }, campaignType) => ({
    ...state,
    workdays: payload.workdays,
    campaign: {
      ...state.campaign,
      ...GET_CAMPAIGN_LAUNCH_PROPERTIES_MAP[campaignType](
        { ...state, workdays: payload.workdays },
        {}
      ),
    },
  }),
  [CHANGE_NAME]: (state, { payload }, campaignType) => ({
    ...state,
    campaign: {
      ...state.campaign,
      name: payload.value,
    },
    validation: {
      ...state.validation,
      name: VALIDATORS_MAP[campaignType].name(payload.value),
    },
  }),
  [CHANGE_TIMEZONE]: (state, { payload }, campaignType) => ({
    ...state,
    campaign: {
      ...state.campaign,
      timezone: payload.value,
    },
    validation: {
      ...state.validation,
      launchTime: state.campaign.launchTime
        ? VALIDATORS_MAP[campaignType].launchTime(
            state.campaign.launchTime,
            state.campaign.launchDate,
            payload.value,
            state.campaign.randomized
          )
        : undefined,
    },
  }),
  [CHANGE_LAUNCH_DATE]: (state, { payload }, campaignType) => {
    const campaignLaunchProperties = GET_CAMPAIGN_LAUNCH_PROPERTIES_MAP[campaignType](state, {
      launchDate: payload.value,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        launchDate: VALIDATORS_MAP[campaignType].launchDate(campaignLaunchProperties.launchDate),
        launchTime: VALIDATORS_MAP[campaignType].launchTime(
          campaignLaunchProperties.launchTime,
          campaignLaunchProperties.launchDate,
          state.campaign.timezone,
          campaignLaunchProperties.randomized
        ),
      },
    }
  },
  [RESET_CAMPAIGN_INPROGRESS_FLAG]: (state) => ({
    ...state,
    campaignInProgressError: false,
    loader: false,
  }),
  [REMOVE_DRAFT_ASYNC.INITIATE]: (state) => ({
    ...state,
    draftLoader: true,
  }),
  [SAVE_DRAFT_ASYNC.INITIATE]: (state) => ({
    ...state,
    draftLoader: true,
    draftError: null,
    draftGotManaged: false,
  }),
  [SAVE_DRAFT_ASYNC.SUCCESS]: (state) => ({
    ...state,
    draftLoader: false,
    draftError: null,
    draftGotManaged: true,
  }),
  [SAVE_DRAFT_ASYNC.ERROR]: (state, { error }) => ({
    ...state,
    draftLoader: false,
    draftError: error,
  }),
  [SAVE_DRAFT_ASYNC.CANCEL]: (state) => ({
    ...state,
    draftLoader: false,
  }),
  [REMOVE_DRAFT_ASYNC.INITIATE]: (state) => ({
    ...state,
    draftLoader: true,
    draftGotManaged: false,
  }),
  [REMOVE_DRAFT_ASYNC.SUCCESS]: (state) => ({
    ...state,
    draftLoader: false,
    draftGotManaged: true,
  }),
  [REMOVE_DRAFT_ASYNC.ERROR]: (state) => ({
    ...state,
    draftLoader: false,
  }),
  [REMOVE_DRAFT_ASYNC.CANCEL]: (state) => ({
    ...state,
    draftLoader: false,
  }),
  [SAVE_AND_APPROVE_CAMPAIGN_ASYNC.INITIATE]: (state) => ({
    ...state,
    loader: true,
  }),
  [SAVE_AND_APPROVE_CAMPAIGN_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      id: payload.data.id,
    },
  }),
  [SAVE_AND_APPROVE_CAMPAIGN_ASYNC.ERROR]: (state, { error }) => ({
    ...state,
    loader: false,
    error,
  }),
  [APPROVE_CAMPAIGN_ASYNC.ERROR]: (state, { error }) => ({
    ...state,
    loader: false,
    error,
    campaign: {
      ...state.campaign,
      selectedScenarios:
        error.response.error === ERROR_CODES.INVALID_SCENARIO
          ? []
          : state.campaign.selectedScenarios,
    },
  }),
  [SAVE_AND_APPROVE_CAMPAIGN_ASYNC.CANCEL]: (state) => ({
    ...state,
    loader: false,
  }),
  [APPROVE_CAMPAIGN_ASYNC.CANCEL]: (state) => ({
    ...state,
    loader: false,
  }),
  [APPROVE_CAMPAIGN_ASYNC.SUCCESS]: (state) => ({
    ...state,
    loader: false,
    gotApproved: true,
  }),
  [SAVE_AND_TEST_CAMPAIGN_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      id: payload.data.id,
    },
  }),
  [CHANGE_LAUNCH_TIME]: (state, { payload }, campaignType) => {
    const campaignLaunchProperties = GET_CAMPAIGN_LAUNCH_PROPERTIES_MAP[campaignType](state, {
      launchTime: payload.value,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        launchTime: VALIDATORS_MAP[campaignType].launchTime(
          campaignLaunchProperties.launchTime,
          campaignLaunchProperties.launchDate,
          state.campaign.timezone,
          campaignLaunchProperties.randomized
        ),
      },
    }
  },
  [CHANGE_SEND_REMINDERS_UNTIL]: (state, { payload }, campaignType) => ({
    ...state,
    campaign: {
      ...state.campaign,
      sendRemindersUntil: payload.value,
    },
    validation: {
      ...state.validation,
      sendRemindersUntil: VALIDATORS_MAP[campaignType].sendRemindersUntil(payload.value),
    },
  }),
  [GET_CAMPAIGN_ASYNC.ERROR]: (state, { error }) => ({
    ...state,
    campaignInProgressError: error.status === 400,
    loader: false,
  }),
  [GET_CAMPAIGN_ASYNC.CANCEL]: (state) => ({
    ...state,
    loader: false,
  }),
  [TOGGLE_SEND_REMINDER_EVERY_X_BUSINESS_DAYS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      sendReminderEveryXBusinessDays: payload.value,
    },
  }),
  [GET_PARTICIPANTS_ASYNC.INITIATE]: (state) => ({
    ...state,
    campaign: {
      ...state.campaign,
      participants: {
        ...state.campaign.participants,
        modalLoader: true,
        error: null,
      },
    },
  }),
  [GET_PARTICIPANTS_ASYNC.ERROR]: (state, { error }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      participants: {
        ...state.campaign.participants,
        meta: {
          ...state.campaign.participants.meta,
          count: 0,
        },
        modalLoader: false,
        selectorLoader: false,
        error,
      },
    },
  }),
  [CHANGE_EXCLUDE_FILTER]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      participants: {
        ...state.campaign.participants,
        modalLoader: true,
        excludeFilter: payload.value,
      },
    },
  }),
  [CHANGE_MODAL_SEARCH]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      participants: {
        ...state.campaign.participants,
        modalSearch: payload.search,
      },
    },
  }),
  [CHANGE_PAGE]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      participants: {
        ...state.campaign.participants,
        page: payload.page,
        modalLoader: true,
      },
    },
  }),
  [TOGGLE_NOTIFY_THOSE_WHO_FAILED]: (state) => ({
    ...state,
    campaign: {
      ...state.campaign,
      sendCampaignFailedEmail: !state.campaign.sendCampaignFailedEmail,
    },
  }),
  [TOGGLE_SEND_CAMPAIGN_SUMMARY_TO_CAMPAIGN_REPORT_RECIPIENTS]: (state) => ({
    ...state,
    campaign: {
      ...state.campaign,
      sendCampaignSummaryToCampaignReportRecipients:
        !state.campaign.sendCampaignSummaryToCampaignReportRecipients,
    },
  }),
  [CHANGE_SEND_COMPLETION_EMAIL]: (state) => ({
    ...state,
    campaign: {
      ...state.campaign,
      sendCompletionEmail: !state.campaign.sendCompletionEmail,
    },
  }),
  [TOGGLE_COMPLETION_NOTIFICATION_SETTING]: (state, { payload }) => {
    const current = state.campaign.completionNotificationSettings || {}
    return {
      ...state,
      campaign: {
        ...state.campaign,
        completionNotificationSettings: {
          ...current,
          [payload.field]: !current[payload.field],
        },
      },
    }
  },
  [CHANGE_SELECTION_DATA]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      participants: {
        ...state.campaign.participants,
        [payload.field]: payload.value,
      },
    },
  }),
  [SET_SHARED_MAILBOX_PARTICIPANTS]: (state) => ({
    ...state,
    campaign: {
      ...state.campaign,
      sharedMailboxWasExcluded: true,
      participants: {
        ...state.campaign.participants,
        excluded: {
          Tags: [SHARED_MAILBOX],
        },
      },
    },
  }),
  [CHANGE_TRAINING_REMINDERS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      trainingReminders: payload.data,
    },
  }),
  [SET_CONTROLS_MESSAGE]: (state, { payload }) => ({
    ...state,
    controlsMessage: payload.message,
  }),
  [SET_TRAINING_VIDEOS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedTrainingVideo: payload.data,
    },
  }),
  [ADD_CAMPAIGN_NOTIFICATION]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      notifications: state.campaign.notifications.find(
        (notification) => notification.type === payload.notification.type
      )
        ? state.campaign.notifications.map((notification) =>
            notification.type === payload.notification.type ? payload.notification : notification
          )
        : [...state.campaign.notifications, payload.notification],
    },
  }),
  [UPLOAD_VIDEO_LINK_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedTrainingVideo: [payload.trainingVideo],
    },
  }),
  [CREATE_CUSTOM_TRAINING_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedTrainingVideo: [
        {
          id: payload.id,
          name: CUSTOM_MODULE_NAME_FILE,
          vendor: SOURCE_VALUES.CUSTOM_MODULE,
          type: TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value,
          items: [],
        },
      ],
    },
  }),
  [CHANGE_MANAGER_REPORT_REMINDERS_THRESHOLD]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      managerReportRemindersThreshold: payload.value,
    },
  }),
  [CHANGE_SEND_MANAGER_REPORT_EVERY_X_DAYS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      sendManagerReportEveryXDays: payload.value,
    },
  }),
  [CHANGE_MANAGER_REPORT_DAY_OF_WEEK]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      managerReportDayOfWeek: payload.value,
    },
  }),
  [CHANGE_MANAGER_NOTIFICATION_DATA]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      ...payload.data,
    },
  }),
  [CHANGE_TRIGGER_BASED_CAMPAIGN_DATA]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      triggerBasedCampaignData: payload.value,
    },
  }),
  [CHANGE_MAX_REMINDERS_PER_PARTICIPANT]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      maxRemindersPerParticipant: payload.value,
    },
  }),
  [CHANGE_IS_END_DATE_WAS_MANUALLY_CHANGED]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      isEndDateWasManuallyChanged: payload.value,
    },
  }),
  DEFAULT: (state) => state,
}
